import { render, staticRenderFns } from "./TaskEditDialog.vue?vue&type=template&id=04f13fd0&scoped=true"
import script from "./TaskEditDialog.vue?vue&type=script&lang=ts"
export * from "./TaskEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./TaskEditDialog.vue?vue&type=style&index=0&id=04f13fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f13fd0",
  null
  
)

export default component.exports